// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { Home } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";

export const Route = createFileRoute("/_authenticated/home/")({
  component: HomePage,
});

function HomePage() {
  const { t } = useTranslation("back-office");

  return (
    <div>
      <PageHeader title={t("home.title")} icon={Home} />
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <Home className="h-12 w-12 text-muted-foreground mb-4" />
        <h2 className="text-lg font-medium text-muted-foreground">{t("home.title")}</h2>
        <p className="text-sm text-muted-foreground mt-1">Coming soon</p>
      </div>
    </div>
  );
}
